import Spinner from '@ux/spinner';

const LoadingSpinner = () => (
  <div className="text-center" style={{ marginTop: '100px' }}>
    <Spinner inline size="lg" />
  </div>
);

export default LoadingSpinner;
